import { registerLocaleData } from '@angular/common';
import localeVi from '@angular/common/locales/vi';
import { Component, OnInit, HostListener, inject } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MessageService, PrimeNGConfig } from 'primeng/api';
import { Toast } from './core/utils/toast.util';
import { environment } from 'src/environments/environment';
import { delay, of } from 'rxjs';
import { CustomTranslateService } from 'src/app/core/services/custom-translate.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

export const STATE_RENDER_APP = {
  INIT: 'INIT',
  IFRAME: 'IFRAME',
  APP: 'APP',
};

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [MessageService, Toast],
})
export class AppComponent implements OnInit {
  // user: any;
  environment = environment;
  sanitizer = inject(DomSanitizer);
  shopURL?: string;
  iframeUrl: SafeResourceUrl;

  stateView: string = STATE_RENDER_APP.INIT;
  isLoading = false;

  constructor(
    private primeNGConfig: PrimeNGConfig,
    private messageService: MessageService,
    private translator: CustomTranslateService,
    private router: Router,
    private translateService: TranslateService,
  ) {}

  ngOnInit() {
    const lang = this.translator.getCurrentLanguage();
    this.translateService.setDefaultLang('en');
    this.translator.setLanguage(lang);
    registerLocaleData(localeVi, 'vi');

    this.primeNGConfig.setTranslation({
      firstDayOfWeek: 1,
    });

    this.shopURL = `${environment.FE_URL_SALE}shopping`;
    this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      `${environment.ADMIN_HUB_URL}/app-connect`,
    );

    of(true)
      .pipe(delay(5000))
      .subscribe(() => {
        if (this.isLoading) {
          this.messageService.add({
            severity: 'warn',
            detail: this.translator.sentenceCase(
              'common.you-need-super-admin-permissions',
            ),
          });
          setTimeout(() => {
            window.location.href = `${environment.ADMIN_HUB_URL}/login`;
          }, 2000);
        }
      });

    this.translator.language$.subscribe((lang) => {
      if (lang === 'en' || lang === 'vi') {
        this.translate(lang);
      }
    });
  }

  translate(lang: string) {
    this.translateService.use(lang);
    this.translateService
      .get('primeng')
      .subscribe((res) => this.primeNGConfig.setTranslation(res));
  }

  @HostListener('window:message', ['$event'])
  handleReceiveMessage(e: MessageEvent) {
    const currentUrl = this.router.url;
    const regex = /^\/refund-hub\/([^\/]+)\/refund-info\/([A-Za-z0-9]+)$/;
    const match = currentUrl.match(regex);
    if (match) {
      this.isLoading = false;
      this.stateView = STATE_RENDER_APP.APP; 
      return;
    }
 

    if (e?.data?.type === 'authorized') {
      const accessTokenData = e.data?.token?.accessToken;
      const profileData = JSON.parse(e.data?.profile);
      if (accessTokenData && profileData) {
        localStorage.setItem('accessToken', accessTokenData);
        localStorage.setItem('auth', JSON.stringify(profileData));
        this.isLoading = false;

        this.stateView = STATE_RENDER_APP.APP;
      } else {
        window.location.href = `${environment.ADMIN_HUB_URL}/login`;
      }
    }
  }

  onActivate() {
    window.scroll({
      top: 0,
      left: 0,
    });
  }

  isIFrame = (input: HTMLElement | null): input is HTMLIFrameElement =>
    input !== null && input.tagName === 'IFRAME';

  handleOnLoad = () => {
    const frame = document.getElementById('socialLogin');
    if (this.isIFrame(frame) && frame.contentWindow) {
      frame.contentWindow.postMessage({ type: 'connect' }, '*');
    }
  };
}
